import { useQuery } from '@apollo/client'
import { useState, useEffect } from 'react'
import { GET_GEO_LOCATION } from '@chegg-wt/core/queries/GeoLocation'
import {
  GetGeolocation,
  GetGeolocationVariables,
} from '@chegg-wt/core/queries/GetGeoLocation'
import { getLocation } from '@chegg-wt/core/utils/geoLocation'
import { Location } from '../types/upgrade'

export const useGeoLocation = (location?: string) => {
  const geoLocationRequired = location === undefined
  const locationToUse = getLocation(location)
  const [countryCode, setCountryCode] = useState<string>(locationToUse)
  const { data, loading } = useQuery<GetGeolocation, GetGeolocationVariables>(
    GET_GEO_LOCATION,
    {
      fetchPolicy: 'cache-and-network',
      ssr: false,
      skip: !geoLocationRequired,
    }
  )

  useEffect(() => {
    if (!loading && data) {
      if (data.getLocationByIp.countryCode in Location) {
        setCountryCode(data.getLocationByIp.countryCode)
      }
    }
  }, [data, loading])

  return {
    countryCode,
    loading,
  }
}
